/**
 * Open a Dashboard tab. The Dashboard reads ?tab= only when it mounts, so a
 * link INSIDE the Dashboard (e.g. the Founding Circle on the Angels tab →
 * Join BB) can't switch tabs by changing the address. On /dashboard this
 * writes the address (so a reload lands right) and tells the page; elsewhere it
 * returns false and the caller's normal link navigation runs.
 */
export function openDashboardTab(tab: string, params: Record<string, string> = {}): boolean {
  if (typeof window === 'undefined' || window.location.pathname !== '/dashboard') return false;
  try {
    const url = new URL(window.location.href);
    url.searchParams.set('tab', tab);
    for (const [k, v] of Object.entries(params)) url.searchParams.set(k, v);
    window.history.replaceState(window.history.state, '', url.toString());
  } catch { /* ignore */ }
  window.dispatchEvent(new CustomEvent('bb-dashboard-tab', { detail: { tab } }));
  return true;
}
